import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'equine-ui-nx-ach-remove-account',
  templateUrl: './ach-remove-account.component.html',
  styleUrls: ['./ach-remove-account.component.scss'],
  imports: [MatDialogModule, MatButtonModule]
})
export class AchRemoveAccountComponent {

}
